import { Logging } from '#common/logging';
import { withStats } from '#common/stats';
import { ServerSessionStats } from './types/stats';
export class ServerSession {
    proxy;
    tokenProvider;
    filespaceToken;
    sessionToken;
    log = Logging.getLogger('ServerSession');
    statistics = new ServerSessionStats(this.log);
    constructor(proxy, tokenProvider) {
        this.proxy = proxy;
        this.tokenProvider = tokenProvider;
    }
    async getSessionToken() {
        const token = await this.tokenProvider.getFilespaceAccessToken();
        if (token === this.filespaceToken || token.length === 0) {
            return this.sessionToken;
        }
        this.filespaceToken = token;
        this.sessionToken = await withStats(this.statistics.establishSession, async () => {
            return await this.proxy.getSessionToken(token);
        });
        return this.sessionToken;
    }
    stats() {
        return this.statistics;
    }
}
